import { useEffect } from 'react';
import { CalendarRange, ChevronRight, Loader2, MessageSquare, X } from 'lucide-react';

export interface SocialStrategyOption {
  key: string;
  label: string;
  description: string;
  pipeline: string | null; // null = legacy generacja bez strategii
}

interface SocialStrategyPickerModalProps {
  strategies: SocialStrategyOption[];
  onSelect: (strategy: SocialStrategyOption) => void;
  onClose: () => void;
}

export function SocialStrategyPickerModal({ strategies, onSelect, onClose }: SocialStrategyPickerModalProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-surface-raised rounded-xl border border-border w-full max-w-lg p-6 shadow-2xl">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-base font-semibold text-text-primary">Social Media - co generujemy?</h3>
          <button onClick={onClose} className="p-1 text-text-secondary hover:text-text-primary rounded-lg hover:bg-surface-hover transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        {strategies.length === 0 ? (
          <div className="flex items-center justify-center gap-2 py-8 text-xs text-text-muted">
            <Loader2 className="w-4 h-4 animate-spin" />
            Ładowanie...
          </div>
        ) : (
          <div className="space-y-2">
            {strategies.map(strategy => (
              <button
                key={strategy.key}
                onClick={() => onSelect(strategy)}
                className="w-full flex items-start gap-3 p-3 rounded-lg border bg-surface-hover border-border hover:border-accent-primary/30 hover:bg-surface-hover/80 transition-all text-left"
              >
                {strategy.pipeline
                  ? <CalendarRange className="w-5 h-5 shrink-0 mt-0.5 text-accent-secondary" />
                  : <MessageSquare className="w-5 h-5 shrink-0 mt-0.5 text-text-muted" />}
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-text-primary">{strategy.label}</div>
                  <div className="text-[11px] text-text-muted mt-0.5 leading-relaxed">{strategy.description}</div>
                </div>
                <ChevronRight className="w-4 h-4 text-text-disabled shrink-0 mt-0.5" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
